import { useMemo } from 'react';

import { CampaignName } from 'src/common/enums/campaigns';

import { CAMPAIGN_SESSION_STORAGE_KEY } from '../campaigns.types';

export const useCampaignSession = (campaignName: CampaignName): boolean =>
  useMemo(() => sessionStorage.getItem(CAMPAIGN_SESSION_STORAGE_KEY) === campaignName, [campaignName]);
